import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const agentService = {
  getAgents,
  createAgent,
  updateAgent,
  deleteAgent,
  syncAgents,
}

const API_URL = API.BASE_URL + '/v1'

/**
 * `isActive`: leave undefined for the API default (active only), pass
 * false for the inactive ones, or 'all' for everything.
 */
export async function getAgents(search, isActive) {
  const params = {}
  if (search) params['search_words[0]'] = search
  if (isActive !== undefined && isActive !== null && isActive !== '') {
    params.is_active = isActive === 'all' ? 'all' : (isActive ? 1 : 0)
  }
  return apiHelper(API_URL).get('/agents', { params })
}

export function createAgent(data) {
  return apiHelper(API_URL).post('/agents', data)
}

export function updateAgent(uuid, data) {
  return apiHelper(API_URL).put(`/agents/${uuid}`, data)
}

export function deleteAgent(uuid) {
  return apiHelper(API_URL).delete(`/agents/${uuid}`)
}

export function syncAgents() {
  return apiHelper(API_URL).post('/agents/sync')
}
